// Wholesale Coffee Cup Product - Recyclable Single Wall
console.log('🥤 Loading Wholesale Coffee Cup (Recyclable) JavaScript...');

// Variant mapping (Single Wall) with real Shopify variant IDs
const variantMapping = {
  '4oz': {
    '10000': '50882161738010',
    '16000': '50882156036378', 
    '32000': '50882156069146',
    '50000': '50883884777754',
    '64000': '50882156101914'
  },
  '6oz': {
    '10000': '50882161770778',
    '16000': '50882156265754',
    '32000': '50882156298522', 
    '50000': '50883884810522',
    '64000': '50882156331290'
  },
  '8oz': {
    '10000': '50882161803546',
    '16000': '50882156495130',
    '32000': '50882156527898',
    '50000': '50883884843290', 
    '64000': '50882156560666'
  },
  '12oz': {
    '10000': '50882161836314',
    '16000': '50882156921114',
    '32000': '50882156953882',
    '50000': '50883884876058',
    '64000': '50882156986650'
  },
  '16oz': {
    '10000': '50882161869082',
    '16000': '50882157347098', 
    '32000': '50882157379866',
    '50000': '50883884908826',
    '64000': '50882157412634'
  },
  '22oz': {
    '10000': '50882161901850',
    '16000': '50882157773082',
    '32000': '50882157805850',
    '50000': '50883884941594',
    '64000': '50882157838618'
  },
  '24oz': {
    '10000': '50882161934618',
    '16000': '50882158002458',
    '32000': '50882158035226', 
    '50000': '50883884974362',
    '64000': '50882158067994'
  }
};

// Variant mapping for Double Wall (Recyclable) pulled from separate Double Wall product
// Only sizes 8oz, 12oz, 16oz are available for Double Wall in wholesale
const variantMappingDouble = {
  '8oz': {
    '10000': '51112525005082',
    '16000': '51112525037850',
    '32000': '51112525070618',
    '50000': '51112525103386',
    '64000': '51112525136154'
  },
  '12oz': {
    '10000': '51112525168922',
    '16000': '51112525201690',
    '32000': '51112525234458',
    '50000': '51112525267226',
    '64000': '51112525299994'
  },
  '16oz': {
    '10000': '51112525332762',
    '16000': '51112525365530',
    '32000': '51112525398298',
    '50000': '51112525431066',
    '64000': '51112525463834'
  }
};

// Plate fee variant ID 
const plateFeeVariantId = '50882200994074';

// Color restrictions by quantity
const colorRules = {
  '10000': 1,   // 1 color only
  '16000': 2,   // 1-2 colors  
  '32000': 3,   // 1-3 colors
  '50000': 4,   // 1-4 colors
  '64000': 5    // 1-5 colors
};

// Lid variant mapping - wholesale quantities only (10,000+)
const lidVariantMapping = {
  "White": {
    "10000": "50726870090010",
    "16000": "50731610964250",
    "32000": "50731610997018",
    "64000": "50731611029786"
  },
  "Black": {
    "10000": "50726870057242",
    "16000": "50731610898714",
    "32000": "50731610931482",
    "64000": "50731610931482"
  }
};

// Printing plate fee VARIANT IDs
const printingPlateFeeVariantId = "50971398013210"; // Standard
const urgentPlateFeeVariantId = "50971398045978"; // Rushed
      
class CoffeeCupWholesaleProduct {
    constructor() {
    console.log('CoffeeCupWholesaleProduct initialized');
    
    // State
    this.selectedSize = '8oz';
    this.selectedWall = 'Single'; // Single | Double
    this.selectedPrintType = 'Flexographic';
    this.selectedQuantity = 10000;
    this.selectedColours = 1;
    this.requireLids = false;
    this.lidColor = 'Black';
    this.selectedTurnaround = 'standard';
    
    // Live pricing cache
    this.productData = null;
    this.currentUnitPrice = 0;
    this.variantPriceCache = new Map();
    this._pricingRenderCounter = 0;
    this.doubleWallProductData = null; // external Double Wall wholesale ProductJSON
    this.plateFeeUnitPrice = 175; // default fallback; will try to load from plate product variant
    
    // Constants
    this.singleWallUnitsPerCarton = 1000;
    this.doubleWallUnitsPerCarton = 500; // Double wall uses different cartons
    this.UNITS_PER_CARTON = this.singleWallUnitsPerCarton;
    this.LID_PRICE_HIGH_QTY = 0.059; // 1000+ cups
    this.LID_PRICE_LOW_QTY = 0.069;  // <1000 cups
    this.STANDARD_PLATE_FEE = 175; // Standard plate fee
    this.URGENT_PLATE_FEE = 250; // Urgent plate fee
    
    // Rush multipliers for different turnaround times
    this.RUSH_MULTIPLIERS = {
      'standard': 1.0,    // 6 weeks (42 business days) - no surcharge
      '20days': 1.10,     // 20 business days - +10%
      '10days': 1.20,     // 10 business days - +20%
      '5days': 1.30       // 5 business days - +30%
    };
    
    // Colour rules based on quantity (Australian spelling)
    this.colourRules = {
      10000: { min: 1, max: 1 },
      16000: { min: 1, max: 2 },
      32000: { min: 1, max: 3 },
      50000: { min: 1, max: 4 },
      64000: { min: 1, max: 5 }
    };
    
    // Variant mappings for wholesale quantities with actual IDs
    this.variantMappingSingle = variantMapping;
    this.variantMappingDouble = variantMappingDouble;
    this.variantMapping = this.variantMappingSingle;

    // Lid variant mapping - wholesale quantities only (10,000+)
    this.lidVariantMapping = lidVariantMapping;

    // Printing plate fee variant ID (used for adding plate fee line items)
    this.plateFeeVariantId = printingPlateFeeVariantId;
      
    this.init().catch(error => console.error('Initialization error:', error));
    }

  async init() {
    this.setupSizeSelector();
    this.setupWallSelector();
    this.setupPrintTypeSelector();
    this.setupColourSelector();
    this.setupLidsSelector();
    this.setupTurnaroundSelector();
    this.setupTooltips();
    this.setupFormSubmission();
    this.setupFileUpload();
    this.setupShippingCalculator();
    this.setupDynamicDescription();
    // Ensure we have live product data and rebuild mapping from actual variants
    await this.loadProductData();
    // Only rebuild mapping from page JSON for Single Wall; keep Double Wall mapping intact
    if (this.selectedWall !== 'Double') {
      this.rebuildVariantMappingFromProductData();
    }
    await this.loadPlateFeePrice();

    // Sync wall availability against initial size
    if (typeof this.updateWallAvailability === 'function') {
      this.updateWallAvailability();
    }
    this.autoSelectMOQQuantity(); // Auto-select MOQ quantity for initial size/print combination
    await this.updatePricingTable();
    this.checkCartAddSuccess();
    this.preventAutoScroll();
  }

  setupWallSelector() {
    const wallButtons = document.querySelectorAll('.wall-btn');
    this.allowedDoubleSizes = new Set(['8oz', '12oz', '16oz']);
    const incompatiblePopup = document.getElementById('double-wall-incompatible-popup');
    const unavailableIndicator = document.querySelector('#double-wall-btn .unavailable-indicator');

    const refreshUnavailableIndicator = () => {
      const shouldShow = !this.allowedDoubleSizes.has(this.selectedSize);
      const doubleBtn = document.getElementById('double-wall-btn');
      if (unavailableIndicator) {
        unavailableIndicator.style.display = shouldShow ? '' : 'none';
      }
      if (doubleBtn) {
        doubleBtn.classList.toggle('disabled', shouldShow);
      }
      // Auto-revert to Single if currently on Double and size not supported
      if (shouldShow && this.selectedWall === 'Double') {
        const singleBtn = document.querySelector('.wall-btn[data-wall="Single"]');
        if (singleBtn) singleBtn.click();
      }
    };
    refreshUnavailableIndicator();

    wallButtons.forEach(btn => {
      btn.addEventListener('click', () => {
      const chosen = btn.dataset.wall === 'Double' ? 'Double' : 'Single';

      if (chosen === 'Double' && !this.allowedDoubleSizes.has(this.selectedSize)) {
          if (incompatiblePopup) {
            incompatiblePopup.style.opacity = '1';
            incompatiblePopup.style.visibility = 'visible';
            setTimeout(() => {
              incompatiblePopup.style.opacity = '0';
              incompatiblePopup.style.visibility = 'hidden';
            }, 1800);
          }
          return; // keep Single if size not supported
        }

        // Update UI state
        wallButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');

        this.selectedWall = chosen;

        // Swap active mapping and cartons
        if (this.selectedWall === 'Double') {
          this.variantMapping = this.variantMappingDouble;
          this.UNITS_PER_CARTON = this.doubleWallUnitsPerCarton;
        } else {
          this.variantMapping = this.variantMappingSingle;
          this.UNITS_PER_CARTON = this.singleWallUnitsPerCarton;
        }

        // Ensure MOQ from new mapping
        this.autoSelectMOQQuantity();
        refreshUnavailableIndicator();
        this.updatePricingTable();
        this.updateDynamicDescription();
        this.updateMediaGalleryForSelectedVariant();
      });
    });
  }

  updateWallAvailability() {
    const doubleBtn = document.getElementById('double-wall-btn');
    const unavailableIndicator = doubleBtn?.querySelector('.unavailable-indicator');
    const isAllowed = this.allowedDoubleSizes ? this.allowedDoubleSizes.has(this.selectedSize) : ['8oz','12oz','16oz'].includes(this.selectedSize);
    if (doubleBtn) doubleBtn.classList.toggle('disabled', !isAllowed);
    if (unavailableIndicator) unavailableIndicator.style.display = isAllowed ? 'none' : '';
    if (!isAllowed && this.selectedWall === 'Double') {
      const singleBtn = document.querySelector('.wall-btn[data-wall="Single"]');
      if (singleBtn) singleBtn.click();
    }
  }

  // Build mapping from ProductJSON variant titles to ensure IDs match the current product
  rebuildVariantMappingFromProductData() {
    try {
      console.log('[DEBUG] rebuildVariantMappingFromProductData called');
      console.log('[DEBUG] this.productData exists:', !!this.productData);
      console.log('[DEBUG] this.productData.variants is array:', Array.isArray(this.productData?.variants));
      
      if (!this.productData || !Array.isArray(this.productData.variants)) {
        console.log('[DEBUG] No product data or variants available for rebuilding mapping');
        return;
      }

      const built = { '4oz': {}, '6oz': {}, '8oz': {}, '12oz': {}, '16oz': {}, '22oz': {}, '24oz': {} };
      const quantities = [10000, 16000, 32000, 50000, 64000];

      console.log('[DEBUG] Processing', this.productData.variants.length, 'variants...');
      
      this.productData.variants.forEach((v, index) => {
        const title = (v.title || '').toLowerCase();
        console.log(`[DEBUG] Variant ${index}: ID=${v.id}, Title="${v.title}"`);
        
        // Expect titles to contain size like "4oz" and quantity like "10000", "16000", etc.
        const sizeMatch = title.match(/(4|6|8|12|16|22|24)oz/);
        const qtyMatch = title.match(/(10000|16000|32000|50000|64000)/);
        
        console.log(`[DEBUG] Size match: ${sizeMatch?.[1]}oz, Qty match: ${qtyMatch?.[1]}`);
        
        if (!sizeMatch || !qtyMatch) {
          console.log(`[DEBUG] Skipping variant - no size/qty match`);
          return;
        }

        const size = `${sizeMatch[1]}oz`;
        const qty = qtyMatch[1];

        if (built[size]) {
          built[size][qty] = String(v.id);
          console.log(`[DEBUG] Added mapping: ${size} -> ${qty} -> ${v.id}`);
        }
      });

      // Only adopt if we found at least one mapping row
      const foundAny = Object.values(built).some(map => Object.keys(map).length > 0);
      console.log('[DEBUG] Found any mappings:', foundAny);
      console.log('[DEBUG] Built mapping:', built);
      
      if (foundAny) {
        console.log('[Mapping] Rebuilt variant mapping from product data:', built);
        // Merge with existing mapping so any missing tiers fall back to hard-coded IDs
        for (const size of Object.keys(built)) {
          this.variantMapping[size] = { ...(this.variantMapping[size] || {}), ...built[size] };
        }
        console.log('[DEBUG] Final merged mapping:', this.variantMapping);
      } else {
        console.log('[DEBUG] No mappings found, keeping original hard-coded mapping');
      }
    } catch (e) {
      console.error('[DEBUG] Failed to rebuild variant mapping from product data:', e);
    }
  }

  // Auto-select MOQ quantity based on size and print type
  autoSelectMOQQuantity() {
    const pricingKey = this.getPricingKey();
    const variants = this.variantMapping[pricingKey];
    
    if (!variants) return;
    
    // Get the minimum quantity available for this configuration (which is the MOQ)
    const quantities = Object.keys(variants).map(q => parseInt(q)).sort((a, b) => a - b);
    const moqQuantity = quantities[0]; // First (smallest) quantity is the MOQ
    
    console.log(`Auto-selecting MOQ for ${pricingKey}: ${moqQuantity}`);
    
    // Update the selected quantity
    this.selectedQuantity = moqQuantity;
    
    // Update available colours based on quantity
    this.updateColourAvailability();
  }

  setupSizeSelector() {
    const sizeButtons = document.querySelectorAll('.size-btn');
    console.log('Setting up size selector, found buttons:', sizeButtons.length);
    
    sizeButtons.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        console.log('Size button clicked:', btn.dataset.size);
        
        // Update selection
        sizeButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        
        this.selectedSize = btn.dataset.size;
        console.log('Size selected:', this.selectedSize);
        
        if (typeof this.updateWallAvailability === 'function') {
          this.updateWallAvailability();
        }
        this.autoSelectMOQQuantity(); // Auto-select MOQ quantity when size changes
        this.updatePricingTable();
        this.updateDynamicDescription();
        this.updateMediaGalleryForSelectedVariant();
      });
    });
  }
  
  setupPrintTypeSelector() {
    const printButtons = document.querySelectorAll('.print-type-btn');
    console.log('[PrintType Debug] Setting up print type selector, found buttons:', printButtons.length);
    
    printButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        // Update selection
        printButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        
        this.selectedPrintType = btn.dataset.printType;
        console.log('Print type selected:', this.selectedPrintType);
        
        // Auto-select MOQ quantity based on new print type
        this.autoSelectMOQQuantity();
        
        this.updatePricingTable();
        this.updateMediaGalleryForSelectedVariant();
      });
    });
  }

  setupColourSelector() {
    const colourButtons = document.querySelectorAll('.color-btn');
    console.log('Setting up colour selector, found buttons:', colourButtons.length);
    
    colourButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('disabled')) {
          return;
        }
        
        // Update selection
        colourButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        
        this.selectedColours = parseInt(btn.dataset.colors);
        console.log('Colours selected:', this.selectedColours);
        
        this.updateOrderSummary();
      });
    });
  }

  updateColourAvailability() {
    const colourButtons = document.querySelectorAll('.color-btn');
    const availabilityNote = document.getElementById('color-availability-note');
    
    const rules = this.colourRules[this.selectedQuantity];
    if (!rules) return;
    
    colourButtons.forEach(btn => {
      const colours = parseInt(btn.dataset.colors);
      
      if (colours >= rules.min && colours <= rules.max) {
        btn.classList.remove('disabled');
        btn.disabled = false;
      } else {
        btn.classList.add('disabled');
        btn.disabled = true;
        
        // If currently selected colour is now disabled, select the max available
        if (colours === this.selectedColours && colours > rules.max) {
          const maxBtn = document.querySelector(`[data-colors="${rules.max}"]`);
          if (maxBtn) {
            colourButtons.forEach(b => b.classList.remove('selected'));
            maxBtn.classList.add('selected');
            this.selectedColours = rules.max;
          }
        }
      }
    });
    
    // Update availability note
    if (availabilityNote) {
      if (rules.min === rules.max) {
        availabilityNote.textContent = `Available colours: ${rules.min} for selected quantity`;
      } else {
        availabilityNote.textContent = `Available colours: ${rules.min}-${rules.max} for selected quantity`;
      }
    }
  }
  
  setupLidsSelector() {
    const lidsPills = document.querySelectorAll('.lids-pill');
    lidsPills.forEach(pill => {
      pill.addEventListener('click', () => {
        // Update selection
        lidsPills.forEach(p => p.classList.remove('selected'));
        pill.classList.add('selected');
        
        const lidsValue = pill.dataset.lids;
        this.requireLids = lidsValue !== 'no';
        this.lidColor = lidsValue === 'yes-white' ? 'White' : 'Black';
        
        console.log('Lids selected:', lidsValue, 'requireLids:', this.requireLids, 'lidColor:', this.lidColor);
        
        this.updatePricingTable();
      });
    });
  }
  
  setupTurnaroundSelector() {
    const turnaroundPills = document.querySelectorAll('.turnaround-pill');
    turnaroundPills.forEach(pill => {
      pill.addEventListener('click', () => {
        // Update selection
        turnaroundPills.forEach(p => p.classList.remove('selected'));
        pill.classList.add('selected');
        
        this.selectedTurnaround = pill.dataset.turnaround || 'standard';
        console.log('Turnaround selected:', this.selectedTurnaround);
        
        this.updatePricingTable();
        this.updateShippingCalculator();
      });
    });
  }

  setupTooltips() {
    const tooltipIcons = document.querySelectorAll('.tooltip-icon[data-tooltip]');
    
    tooltipIcons.forEach(icon => {
      let tooltip = null;
      
      const showTooltip = (e) => {
        // Remove any existing tooltips
        document.querySelectorAll('.tooltip-popup').forEach(t => t.remove());
        
        const tooltipText = icon.getAttribute('data-tooltip');
        if (!tooltipText) return;
        
        // Create tooltip element
        tooltip = document.createElement('div');
        tooltip.className = 'tooltip-popup';
        tooltip.innerHTML = tooltipText;
        
        // Style the tooltip
        Object.assign(tooltip.style, {
          position: 'absolute',
          background: '#000000',
          color: '#ffffff',
          padding: '12px 16px',
          borderRadius: '6px',
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '1.4',
          maxWidth: '300px',
          width: 'auto',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          zIndex: '9999',
          opacity: '0',
          visibility: 'hidden',
          transition: 'all 0.2s ease',
          pointerEvents: 'none'
        });
        
        // Add to DOM - append to the icon's parent container for better positioning
        const container = icon.closest('.form__label') || icon.parentElement;
        container.style.position = 'relative';
        container.appendChild(tooltip);
        
        // Position tooltip relative to icon
        const iconRect = icon.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        
        // Get tooltip dimensions after adding to DOM
        tooltip.style.visibility = 'visible';
        tooltip.style.opacity = '0';
        const tooltipRect = tooltip.getBoundingClientRect();
        tooltip.style.visibility = 'hidden';
        
        // Calculate position relative to container
        const iconLeft = iconRect.left - containerRect.left;
        const iconTop = iconRect.top - containerRect.top;
        
        // Position above the icon, centered horizontally
        let left = iconLeft + (iconRect.width / 2) - (tooltipRect.width / 2);
        let top = iconTop - tooltipRect.height - 8;
        
        // Keep tooltip within viewport
        const viewportWidth = window.innerWidth;
        const tooltipLeftInViewport = containerRect.left + left;
        const tooltipRightInViewport = tooltipLeftInViewport + tooltipRect.width;
        
        // Adjust horizontal position if going off screen
        if (tooltipLeftInViewport < 10) {
          left = 10 - containerRect.left;
        } else if (tooltipRightInViewport > viewportWidth - 10) {
          left = (viewportWidth - 10 - containerRect.left) - tooltipRect.width;
        }
        
        // If no room above, show below
        if (containerRect.top + top < 10) {
          top = iconTop + iconRect.height + 8;
        }
        
        tooltip.style.left = left + 'px';
        tooltip.style.top = top + 'px';
        
        // Show tooltip
        requestAnimationFrame(() => {
          tooltip.style.opacity = '1';
          tooltip.style.visibility = 'visible';
        });
      };
      
      const hideTooltip = () => {
        if (tooltip) {
          tooltip.style.opacity = '0';
          tooltip.style.visibility = 'hidden';
          setTimeout(() => {
            if (tooltip && tooltip.parentNode) {
              tooltip.parentNode.removeChild(tooltip);
            }
            tooltip = null;
          }, 200);
        }
      };
      
      // Add event listeners
      icon.addEventListener('mouseenter', showTooltip);
      icon.addEventListener('mouseleave', hideTooltip);
      icon.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    });
    
    // Clean up tooltips on page interactions
    document.addEventListener('scroll', () => {
      document.querySelectorAll('.tooltip-popup').forEach(t => {
        if (t.parentNode) t.parentNode.removeChild(t);
      });
    });
    
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.tooltip-icon')) {
        document.querySelectorAll('.tooltip-popup').forEach(t => {
          if (t.parentNode) t.parentNode.removeChild(t);
        });
      }
    });
  }

  setupShippingCalculator() {
    // Initialize the shipping calculator on page load
    this.updateShippingCalculator();
  }

  updateShippingCalculator() {
    const currentDate = new Date();
    const deliveryRangeEl = document.getElementById('delivery-range');
    const orderDateEl = document.getElementById('order-date');
    const shippedDateEl = document.getElementById('shipped-date');
    const doorstepDateEl = document.getElementById('doorstep-date');

    if (!deliveryRangeEl || !orderDateEl || !shippedDateEl || !doorstepDateEl) {
      console.log('Shipping calculator elements not found');
      return;
    }

    // Determine production days and shipping times based on turnaround selection
    let productionDays, minDeliveryDays, maxDeliveryDays;
    
    switch (this.selectedTurnaround) {
      case '5days':
        productionDays = 5;
        minDeliveryDays = 6;
        maxDeliveryDays = 8;
        break;
      case '10days':
        productionDays = 10;
        minDeliveryDays = 11;
        maxDeliveryDays = 13;
        break;
      case '15days':
        productionDays = 15;
        minDeliveryDays = 16;
        maxDeliveryDays = 18;
        break;
      case 'standard':
      default:
        productionDays = 30; // 30 business days
        minDeliveryDays = 31;
        maxDeliveryDays = 33;
        break;
    }

    // Calculate dates
    const orderDate = new Date(currentDate);
    const shippedDate = this.addBusinessDays(orderDate, productionDays);
    const doorstepDate = this.addBusinessDays(orderDate, maxDeliveryDays);
    const minDoorstepDate = this.addBusinessDays(orderDate, minDeliveryDays);

    // Format dates
    const formatDate = (date) => {
      const options = { month: 'short', day: 'numeric' };
      const suffix = this.getDateSuffix(date.getDate());
      return date.toLocaleDateString('en-US', options).replace(/\d+/, date.getDate() + suffix);
    };

    // Update delivery range with selected production time
    let productionTimeText;
    switch (this.selectedTurnaround) {
      case '5days':
        productionTimeText = 'Urgent (5 business days) +25%';
        break;
      case '10days':
        productionTimeText = 'Rushed (10 business days) +15%';
        break;
      case '15days':
        productionTimeText = 'Express (15 business days) +8%';
        break;
      case 'standard':
      default:
        productionTimeText = 'Standard (30 business days)';
        break;
    }
    
    if (minDeliveryDays === maxDeliveryDays) {
      deliveryRangeEl.textContent = `${productionTimeText} ${formatDate(doorstepDate)}`;
    } else {
      deliveryRangeEl.textContent = `${productionTimeText} ${formatDate(minDoorstepDate)} to ${formatDate(doorstepDate)}`;
    }

    // Update timeline dates
    orderDateEl.textContent = formatDate(orderDate);
    shippedDateEl.textContent = formatDate(shippedDate);
    doorstepDateEl.textContent = formatDate(doorstepDate);
  }

  addBusinessDays(startDate, days) {
    const result = new Date(startDate);
    let addedDays = 0;

    while (addedDays < days) {
      result.setDate(result.getDate() + 1);
      // Skip weekends (Saturday = 6, Sunday = 0)
      if (result.getDay() !== 0 && result.getDay() !== 6) {
        addedDays++;
      }
    }

    return result;
  }

  getDateSuffix(day) {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  setupDynamicDescription() {
    // Initialize with default size (4oz)
    this.updateDynamicDescription();
    
    // Setup accordion dropdown functionality (only one open at a time)
    this.setupAccordionBehavior('.dynamic-description'); // Desktop version
    this.setupAccordionBehavior('.dynamic-description-mobile'); // Mobile version
    
    // Auto-open the first tab (Description) on page load
    this.openDescriptionTab();
  }

  openDescriptionTab() {
    // Open description tab on desktop
    const desktopDescriptionTitle = document.querySelector('.dynamic-description .dropdown-title[data-target="description-content"]');
    const desktopDescriptionContent = document.getElementById('description-content');
    
    if (desktopDescriptionTitle && desktopDescriptionContent) {
      desktopDescriptionTitle.classList.add('active');
      desktopDescriptionContent.classList.add('active');
    }
    
    // Open description tab on mobile
    const mobileDescriptionTitle = document.querySelector('.dynamic-description-mobile .dropdown-title[data-target="description-content-mobile"]');
    const mobileDescriptionContent = document.getElementById('description-content-mobile');
    
    if (mobileDescriptionTitle && mobileDescriptionContent) {
      mobileDescriptionTitle.classList.add('active');
      mobileDescriptionContent.classList.add('active');
    }
  }

  setupAccordionBehavior(containerSelector) {
    console.log('Setting up accordion behavior for:', containerSelector);
    const container = document.querySelector(containerSelector);
    if (!container) {
      console.log('Container not found:', containerSelector);
      return;
    }
    
    const dropdownTitles = container.querySelectorAll('.dropdown-title');
    console.log('Found dropdown titles:', dropdownTitles.length);
    
    dropdownTitles.forEach((title, index) => {
      console.log(`Styling dropdown title ${index}:`, title.textContent);
      // Force bold styling directly on the element
      title.style.fontWeight = '700';
      title.style.fontWeight = 'bold';
      title.style.setProperty('font-weight', '700', 'important');
      console.log('Applied styles to:', title.textContent, 'font-weight:', title.style.fontWeight);
      
      title.addEventListener('click', (e) => {
        const targetId = title.getAttribute('data-target');
        const content = document.getElementById(targetId);
        
        if (content) {
          const isCurrentlyActive = title.classList.contains('active');
          
          // Close all dropdowns in this container first
          dropdownTitles.forEach(otherTitle => {
            const otherTargetId = otherTitle.getAttribute('data-target');
            const otherContent = document.getElementById(otherTargetId);
            
            if (otherContent) {
              otherTitle.classList.remove('active');
              otherContent.classList.remove('active');
            }
          });
          
          // If this wasn't active, open it
          if (!isCurrentlyActive) {
            title.classList.add('active');
            content.classList.add('active');
          }
        }
      });
    });
  }

  updateDynamicDescription() {
    const descriptionData = this.getDescriptionData();
    
    // Update desktop version
    const descriptionContent = document.getElementById('description-content');
    const specificationContent = document.getElementById('specification-content');
    const dielinesContent = document.getElementById('dielines-content');
    const howItWorksContent = document.getElementById('how-it-works-content');
    
    // Update mobile version
    const descriptionContentMobile = document.getElementById('description-content-mobile');
    const specificationContentMobile = document.getElementById('specification-content-mobile');
    const dielinesContentMobile = document.getElementById('dielines-content-mobile');
    const howItWorksContentMobile = document.getElementById('how-it-works-content-mobile');
    
    if (descriptionData) {
      // Update desktop
      if (descriptionContent) {
        descriptionContent.innerHTML = descriptionData.description;
      }
      if (specificationContent) {
        specificationContent.innerHTML = descriptionData.specification;
      }
      if (dielinesContent) {
        dielinesContent.innerHTML = descriptionData.dielines;
      }
      if (howItWorksContent && !howItWorksContent.hasAttribute('data-static-journey')) {
        howItWorksContent.innerHTML = descriptionData.howItWorks;
      }
      
      // Update mobile (same content)
      if (descriptionContentMobile) {
        descriptionContentMobile.innerHTML = descriptionData.description;
      }
      if (specificationContentMobile) {
        specificationContentMobile.innerHTML = descriptionData.specification;
      }
      if (dielinesContentMobile) {
        dielinesContentMobile.innerHTML = descriptionData.dielines;
      }
      if (howItWorksContentMobile && !howItWorksContentMobile.hasAttribute('data-static-journey')) {
        howItWorksContentMobile.innerHTML = descriptionData.howItWorks;
      }
    }
  }

  getHowItWorksMarkup() {
    return `
      <div class="process-timeline">
        <div class="process-step">
          <div class="process-number">1</div>
          <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and print type, upload artwork, and finalise your order details.</div>
        </div>
        <div class="process-step">
          <div class="process-number">2</div>
          <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
        </div>
        <div class="process-step">
          <div class="process-number">3</div>
          <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom cups go into production — standard turnaround is 30 business days.</div>
        </div>
        <div class="process-step">
          <div class="process-number">4</div>
          <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
        </div>
      </div>
    `;
  }

  getDescriptionData() {
    const sizeDescriptions = {
      "4oz": {
        description: `
          <p>Our 4oz (110ml) Wholesale Cups are designed for high-volume commercial applications. Perfect for sampling, espresso service, and large-scale promotional campaigns with premium flexographic printing quality.</p>
          <p>Available with <strong>Flexographic printing only</strong> — fast, cost-effective production with excellent coverage for wholesale quantities.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">110ml (4oz)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
            <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Flexographic printing only</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">10,000 units</span></li>
            <li><span class="spec-label">Max Quantity:</span> <span class="spec-value">64,000 units</span></li>
            <li><span class="spec-label">Lid Size:</span> <span class="spec-value">Fits 62mm PE lids (black or white)</span></li>
            <li><span class="spec-label">Colors Available:</span> <span class="spec-value">1-5 colors (depending on quantity)</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the standard dieline template (same as retail) for artwork setup:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/4oz_Cup_Template_dec3222c-87bb-429d-a6bb-fa2971a2f391.pdf?v=1762387042" class="download-btn" download="4oz_Cup_Template.pdf" target="_blank">👉 Download 4oz Template</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with flexographic printing specifications or bulk artwork setup? Contact our wholesale team.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Configure Your Order</strong><br>Choose size, colors, and wholesale quantity. Each color requires a separate printing plate.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Artwork & Plates</strong><br>Upload your design and we'll create printing plates for each color in your artwork.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Approval Process</strong><br>Review digital mockups and plate proofs before production begins.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Flexographic Production</strong><br>High-speed flexographic printing ensures durable, consistent results across your entire wholesale order.</div>
            </div>
          </div>
        `
      },
      // Add more sizes as needed, following the same pattern
      "8oz": {
        description: `
          <p>Our 8oz (250ml) Wholesale Cups are the industry standard for coffee service. Ideal for large-scale cafe chains, corporate events, and promotional campaigns requiring consistent, high-quality branding.</p>
          <p>Available with <strong>Flexographic printing only</strong> — ideal for large production runs with excellent ink laydown and durability.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">250ml (8oz)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
            <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Flexographic printing only</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">10,000 units</span></li>
            <li><span class="spec-label">Max Quantity:</span> <span class="spec-value">64,000 units</span></li>
            <li><span class="spec-label">Lid Size:</span> <span class="spec-value">Fits 80mm PE lids (black or white)</span></li>
            <li><span class="spec-label">Colors Available:</span> <span class="spec-value">1-5 colors (depending on quantity)</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the standard dieline template (same as retail) for artwork setup:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/8ozA_Cup_Template_cfb40b78-835b-4a1d-9903-0b0b1fbe0aad.pdf?v=1762387042" class="download-btn" download="8ozA_Cup_Template.pdf" target="_blank">👉 Download 8oz Template</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Professional flexographic printing requires precise artwork setup. Our wholesale team can assist with technical specifications.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Configure Your Order</strong><br>Choose size, colors, and wholesale quantity. Each color requires a separate printing plate.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Artwork & Plates</strong><br>Upload your design and we'll create printing plates for each color in your artwork.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Approval Process</strong><br>Review digital mockups and plate proofs before production begins.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Flexographic Production</strong><br>High-speed flexographic printing ensures durable, consistent results across your entire wholesale order.</div>
            </div>
          </div>
        `
      },
      "6oz": {
        description: `
          <p>Our 6oz (220ml) Wholesale Cups offer the perfect balance for cappuccinos and specialty drinks. Designed for high-volume commercial use with superior flexographic printing quality for large-scale branding.</p>
          <p>Available with <strong>Flexographic printing only</strong> — ensuring consistent color reproduction across your entire wholesale order.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">220ml (6oz)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
            <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Flexographic printing only</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">10,000 units</span></li>
            <li><span class="spec-label">Max Quantity:</span> <span class="spec-value">64,000 units</span></li>
            <li><span class="spec-label">Lid Size:</span> <span class="spec-value">Fits 70mm PE lids (black or white)</span></li>
            <li><span class="spec-label">Colors Available:</span> <span class="spec-value">1-5 colors (depending on quantity)</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the standard dieline template (same as retail) for artwork setup:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/6oz_Cup_Template_1c73e735-0971-49f4-a635-27d1ccc98082.pdf?v=1762387042" class="download-btn" download="6oz_Cup_Template.pdf" target="_blank">👉 Download 6oz Template</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Professional flexographic printing for wholesale quantities. Contact our team for artwork specifications.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Configure Your Order</strong><br>Choose size, colors, and wholesale quantity. Each color requires a separate printing plate.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Artwork & Plates</strong><br>Upload your design and we'll create printing plates for each color in your artwork.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Approval Process</strong><br>Review digital mockups and plate proofs before production begins.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Flexographic Production</strong><br>High-speed flexographic printing ensures durable, consistent results across your entire wholesale order.</div>
            </div>
          </div>
        `
      },
      "12oz": {
        description: `
          <p>Our 12oz (395ml) Wholesale Cups are perfect for large coffee servings and specialty beverages. Ideal for coffee chains, corporate offices, and events requiring professional-grade branding with flexographic printing.</p>
          <p>Available with <strong>Flexographic printing only</strong> — delivering exceptional print quality and consistency for wholesale volumes.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">395ml (12oz)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
            <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Flexographic printing only</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">10,000 units</span></li>
            <li><span class="spec-label">Max Quantity:</span> <span class="spec-value">64,000 units</span></li>
            <li><span class="spec-label">Lid Size:</span> <span class="spec-value">Fits 90mm PE lids (black or white)</span></li>
            <li><span class="spec-label">Colors Available:</span> <span class="spec-value">1-5 colors (depending on quantity)</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the standard dieline template (same as retail) for artwork setup:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/12ozXL_Cup_Template_c505dcd4-b799-4a04-8198-a09eb49137f9.pdf?v=1762387042" class="download-btn" download="12ozXL_Cup_Template.pdf" target="_blank">👉 Download 12oz Template</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Large format cups require precise artwork setup. Our wholesale team provides technical support.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Configure Your Order</strong><br>Choose size, colors, and wholesale quantity. Each color requires a separate printing plate.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Artwork & Plates</strong><br>Upload your design and we'll create printing plates for each color in your artwork.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Approval Process</strong><br>Review digital mockups and plate proofs before production begins.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Flexographic Production</strong><br>High-speed flexographic printing ensures durable, consistent results across your entire wholesale order.</div>
            </div>
          </div>
        `
      },
      "16oz": {
        description: `
          <p>Our 16oz (480ml) Wholesale Cups are designed for extra-large servings and premium beverage presentations. Perfect for coffee shops, corporate catering, and large-scale promotional campaigns with professional flexographic printing.</p>
          <p>Available with <strong>Flexographic printing only</strong> — excellent coverage and durability for high-volume applications.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">480ml (16oz)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
            <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Flexographic printing only</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">10,000 units</span></li>
            <li><span class="spec-label">Max Quantity:</span> <span class="spec-value">64,000 units</span></li>
            <li><span class="spec-label">Lid Size:</span> <span class="spec-value">Fits 90mm PE lids (black or white)</span></li>
            <li><span class="spec-label">Colors Available:</span> <span class="spec-value">1-5 colors (depending on quantity)</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the standard dieline template (same as retail) for artwork setup:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/16oz_Cup_Template_5d34a8ce-aeed-44d5-94b7-c11b8cc00656.pdf?v=1762387042" class="download-btn" download="16oz_Cup_Template.pdf" target="_blank">👉 Download 16oz Template</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Large format wholesale cups with premium flexographic printing capabilities. Contact our team for artwork guidance.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Configure Your Order</strong><br>Choose size, colors, and wholesale quantity. Each color requires a separate printing plate.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Artwork & Plates</strong><br>Upload your design and we'll create printing plates for each color in your artwork.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Approval Process</strong><br>Review digital mockups and plate proofs before production begins.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Flexographic Production</strong><br>High-speed flexographic printing ensures durable, consistent results across your entire wholesale order.</div>
            </div>
          </div>
        `
      },
      "22oz": {
        description: `
          <p>Our 22oz (610ml) Wholesale Cups are designed for extra-large cold beverages and specialty drinks. Perfect for bubble tea shops, smoothie bars, and large-scale promotional events requiring maximum brand visibility with flexographic printing.</p>
          <p>Available with <strong>Flexographic printing only</strong> — exceptional consistency for wholesale volumes.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">610ml (22oz)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
            <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Flexographic printing only</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">10,000 units</span></li>
            <li><span class="spec-label">Max Quantity:</span> <span class="spec-value">64,000 units</span></li>
            <li><span class="spec-label">Lid Size:</span> <span class="spec-value">Fits 95mm PE lids (black or white)</span></li>
            <li><span class="spec-label">Colors Available:</span> <span class="spec-value">1-5 colors (depending on quantity)</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the standard dieline template (same as retail) for artwork setup:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/22oz_Cup_Template_bbce4521-f3c9-4f92-9c3b-aa99cf3594e3.pdf?v=1762387042" class="download-btn" download="22oz_Cup_Template.pdf" target="_blank">👉 Download 22oz Template</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Extra-large format requires specialized artwork setup. Our wholesale team provides comprehensive support.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Configure Your Order</strong><br>Choose size, colors, and wholesale quantity. Each color requires a separate printing plate.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Artwork & Plates</strong><br>Upload your design and we'll create printing plates for each color in your artwork.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Approval Process</strong><br>Review digital mockups and plate proofs before production begins.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Flexographic Production</strong><br>High-speed flexographic printing ensures durable, consistent results across your entire wholesale order.</div>
            </div>
          </div>
        `
      },
      "24oz": {
        description: `
          <p>Our 24oz (730ml) Wholesale Cups are the largest option for premium cold beverages and specialty drinks. Ideal for smoothie chains, juice bars, and large-scale events requiring maximum impact with professional flexographic printing.</p>
          <p>Available with <strong>Flexographic printing only</strong> — delivering superior brand visibility for wholesale applications.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">730ml (24oz)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
            <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Flexographic printing only</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">10,000 units</span></li>
            <li><span class="spec-label">Max Quantity:</span> <span class="spec-value">64,000 units</span></li>
            <li><span class="spec-label">Lid Size:</span> <span class="spec-value">Fits 95mm PE lids (black or white)</span></li>
            <li><span class="spec-label">Colors Available:</span> <span class="spec-value">1-2 colors (depending on quantity)</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the standard dieline template (same as retail) for artwork setup:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/24oz_Cup_Template_52348637-3c54-4999-beac-c0c96d9f96cc.pdf?v=1762387042" class="download-btn" download="24oz_Cup_Template.pdf" target="_blank">👉 Download 24oz Template</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Maximum size format with premium printing capabilities. Our team provides full technical support for artwork preparation.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Configure Your Order</strong><br>Choose size, colors, and wholesale quantity. Each color requires a separate printing plate.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Artwork & Plates</strong><br>Upload your design and we'll create printing plates for each color in your artwork.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Approval Process</strong><br>Review digital mockups and plate proofs before production begins.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Flexographic Production</strong><br>High-speed flexographic printing ensures durable, consistent results across your entire wholesale order.</div>
            </div>
          </div>
        `
      }
    };
    
    // Double Wall content (8/12/16) - mirror retail DW templates, adapted to wholesale flexo
    const sizeDescriptionsDouble = {
      "8oz": {
        description: `
          <p>Our 8oz (250ml) <strong>Double Wall</strong> Recyclable Wholesale Cups provide better heat insulation for hot beverages at volume. Double Wall removes the need for sleeves.</p>
          <p>Wholesale printing is <strong>Flexographic</strong> for durable, high-speed production.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">250ml (8oz)</span></li>
            <li><span class="spec-label">Construction:</span> <span class="spec-value">Double Wall</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Flexographic (wholesale)</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the Double Wall template for precise print placement:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/8ozA_Double_Wall_Cup_Template_ea30899c-7167-40f1-964e-4b68d177f846.pdf?v=1762386998" class="download-btn" download="8ozA_Double_Wall_Cup_Template.pdf" target="_blank">👉 Download 8oz Double Wall Template</a>
        `
      },
      "12oz": {
        description: `
          <p>Our 12oz (395ml) <strong>Double Wall</strong> Recyclable Wholesale Cups offer comfortable handling without sleeves for medium serves.</p>
          <p>Wholesale printing is <strong>Flexographic</strong> to suit high-volume production.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">395ml (12oz)</span></li>
            <li><span class="spec-label">Construction:</span> <span class="spec-value">Double Wall</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Flexographic (wholesale)</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the Double Wall template for precise print placement:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/12ozXL_Double_Wall_Cup_Template_5489dcae-8e3f-4cd8-819f-5cdc549b2ae2.pdf?v=1762386998" class="download-btn" download="12ozXL_Double_Wall_Cup_Template.pdf" target="_blank">👉 Download 12oz Double Wall Template</a>
        `
      },
      "16oz": {
        description: `
          <p>Our 16oz (480ml) <strong>Double Wall</strong> Recyclable Wholesale Cups deliver superior insulation for large hot drinks.</p>
          <p>Wholesale printing is <strong>Flexographic</strong> for consistent coverage across big runs.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">480ml (16oz)</span></li>
            <li><span class="spec-label">Construction:</span> <span class="spec-value">Double Wall</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Flexographic (wholesale)</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the Double Wall template for precise print placement:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/16oz_Double_Wall_Cup_Template_045d62b5-215e-4b46-9715-0ffd0685cc4b.pdf?v=1762386998" class="download-btn" download="16oz_Double_Wall_Cup_Template.pdf" target="_blank">👉 Download 16oz Double Wall Template</a>
        `
      }
    };

    const map = this.selectedWall === 'Double' ? sizeDescriptionsDouble : sizeDescriptions;
    const base = map[this.selectedSize] || (this.selectedWall === 'Double' ? sizeDescriptionsDouble['8oz'] : sizeDescriptions['4oz']);
    return { ...base, howItWorks: this.getHowItWorksMarkup() };
  }
  
  setupFormSubmission() {
    const customButton = document.getElementById('custom-add-to-cart-btn');
    if (customButton) {
      customButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.addToCart();
      });
    }
  }
  
  setupFileUpload() {
    const fileInput = document.querySelector('#product-form-cup-wholesale input[type="file"][name="properties[Design File]"]');
    if (!fileInput) {
      console.log('File upload input not found');
      return;
    }

    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');
    const fileInfo = document.querySelector('div[id^="fileInfo-"]');
    const fileName = document.querySelector('div[id^="fileName-"]');
    const fileSize = document.querySelector('div[id^="fileSize-"]');
    const removeButton = document.querySelector('button[id^="removeFile-"]');

    // Click handler for upload area
    if (uploadArea) {
      uploadArea.addEventListener('click', () => {
        fileInput.click();
      });

      // Drag and drop handlers
      uploadArea.addEventListener('dragover', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#3b82f6';
        uploadArea.style.backgroundColor = '#eff6ff';
      });

      uploadArea.addEventListener('dragleave', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#cbd5e1';
        uploadArea.style.backgroundColor = '#f8fafc';
      });

      uploadArea.addEventListener('drop', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#cbd5e1';
        uploadArea.style.backgroundColor = '#f8fafc';
        
        const files = e.dataTransfer.files;
        if (files.length) {
          fileInput.files = files;
          this.handleFileSelection(files[0]);
        }
      });
    }

    // File selection handler
    fileInput.addEventListener('change', (e) => {
      const file = e.target.files[0];
      this.handleFileSelection(file);
    });

    // Remove file handler
    if (removeButton) {
      removeButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.clearFileSelection();
      });
    }
  }

  handleFileSelection(file) {
    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');
    const fileName = document.querySelector('div[id^="fileName-"]');
    const fileSize = document.querySelector('div[id^="fileSize-"]');

    if (!file) {
      this.clearFileSelection();
      return;
    }

    // Validate file size (max 10MB)
    if (file.size > 10 * 1024 * 1024) {
      alert('File size must be less than 10MB');
      this.clearFileSelection();
      return;
    }

    // Hide upload area and show preview
    if (uploadArea) uploadArea.style.display = 'none';
    if (filePreviewArea) filePreviewArea.style.display = 'block';

    // Update file info
    if (fileName) fileName.textContent = file.name;
    if (fileSize) fileSize.textContent = `${(file.size / 1024 / 1024).toFixed(2)}MB`;

    // Show image preview for image files
    if (file.type.startsWith('image/') && imagePreview) {
      const reader = new FileReader();
      reader.onload = (e) => {
        imagePreview.src = e.target.result;
        imagePreview.style.display = 'block';
      };
      reader.readAsDataURL(file);
    } else {
      // Hide image preview for non-image files
      if (imagePreview) imagePreview.style.display = 'none';
    }

    console.log('File selected:', file.name, file.type, file.size);
  }

  clearFileSelection() {
    const fileInput = document.querySelector('#product-form-cup-wholesale input[type="file"][name="properties[Design File]"]');
    const uploadArea = document.querySelector('#product-form-cup-wholesale div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('#product-form-cup-wholesale img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('#product-form-cup-wholesale div[id^="filePreviewArea-"]');

    // Clear the file input
    if (fileInput) fileInput.value = '';

    // Show upload area and hide preview
    if (uploadArea) uploadArea.style.display = 'block';
    if (filePreviewArea) filePreviewArea.style.display = 'none';
    if (imagePreview) imagePreview.style.display = 'none';

    console.log('File selection cleared');
  }
  
  getPricingKey() {
    // Mapping keys are by size only (Offset is the only print type for wholesale)
    return `${this.selectedSize}`;
  }

  // Helper function to get the appropriate lid quantity based on cup quantity
  getLidQuantityTier(cupQuantity) {
    // Map cup quantities to lid variant quantity tiers
    if (cupQuantity >= 64000) return "64000";
    if (cupQuantity >= 50000) return "50000";
    if (cupQuantity >= 32000) return "32000";
    if (cupQuantity >= 16000) return "16000";
    return "10000";
  }

  async loadProductData() {
    if (this.productData) return this.productData;
    
    try {
      console.log('[DEBUG] Starting loadProductData...');
      
      // First try to get from existing ProductJSON script
      const productScript = document.querySelector(`script[id^="ProductJSON-"]`);
      console.log('[DEBUG] ProductJSON script found:', !!productScript);
      
      if (productScript) {
        console.log('[DEBUG] ProductJSON script ID:', productScript.id);
        this.productData = JSON.parse(productScript.textContent);
        console.log('[DEBUG] Loaded product data from script:', this.productData.handle);
        console.log('[DEBUG] Product has variants:', this.productData.variants?.length || 0);
        if (this.productData.variants?.length > 0) {
          console.log('[DEBUG] First 3 variant IDs:', this.productData.variants.slice(0, 3).map(v => v.id));
          console.log('[DEBUG] Sample variant titles:', this.productData.variants.slice(0, 3).map(v => v.title));
        }
        return this.productData;
      }
      
      // Fallback: fetch from API using product handle from URL
      const pathParts = window.location.pathname.split('/');
      const handle = pathParts[pathParts.indexOf('products') + 1];
      console.log('[DEBUG] Extracted handle from URL:', handle);
      
      if (handle) {
        console.log('[DEBUG] Fetching from API...');
        const response = await fetch(`/products/${handle}.js`);
        this.productData = await response.json();
        console.log('[DEBUG] Loaded product data from API:', this.productData.handle);
        return this.productData;
      }
      
      throw new Error('Could not determine product handle');
    } catch (error) {
      console.error('[DEBUG] Failed to load product data:', error);
      return null;
    }
  }

  // Fetch variant price in dollars with robust parsing and cache support
  async fetchVariantPriceDollars(variantId) {
    if (!variantId) return null;
    if (this.variantPriceCache && this.variantPriceCache.has(variantId)) {
      return this.variantPriceCache.get(variantId);
    }
    const endpoints = [
      `/variants/${variantId}.json`,
      `/variants/${variantId}.js`
    ];
    for (const url of endpoints) {
      try {
        const res = await fetch(url, { headers: { 'Accept': 'application/json,text/plain,*/*' } });
        if (!res.ok) continue;
        let data;
        try { data = await res.clone().json(); }
        catch(_) { const t = await res.text(); try { data = JSON.parse(t); } catch(_) { const m = /"price"\s*:\s*"?([0-9]+(?:\.[0-9]+)?)"?/i.exec(t); if (m) { const num = parseFloat(m[1]); if (isFinite(num)) { if (this.variantPriceCache) this.variantPriceCache.set(variantId, num); return num; } } continue; } }
        const v = data?.variant || data;
        if (!v) continue;
        let p = v.price; p = typeof p === 'string' ? parseFloat(p) : Number(p);
        if (!isFinite(p)) continue; if (p > 100 && Number.isInteger(p)) p = p / 100;
        if (this.variantPriceCache) this.variantPriceCache.set(variantId, p);
        return p;
      } catch(_) {}
    }
    return null;
  }

  async fetchVariantPricesBatch(ids) {
    const unique = [...new Set((ids || []).filter(Boolean))];
    const missing = unique.filter(id => !(this.variantPriceCache && this.variantPriceCache.has(id)));
    await Promise.all(missing.map(id => this.fetchVariantPriceDollars(id)));
  }

  async loadDoubleWallProductData() {
    if (this.doubleWallProductData) return this.doubleWallProductData;
    const provided = window.DOUBLE_WALL_WHOLESALE_HANDLE;
    const handles = [];
    if (provided) handles.push(provided);
    handles.push(
      'wholesale-custom-coffee-cups-double-wall-recyclable',
      'wholesale-custom-coffee-cups-double-wall',
      'custom-coffee-cups-double-wall-recyclable-wholesale'
    );
    for (const h of handles) {
      try {
        const res = await fetch(`/products/${h}.js`);
        if (!res.ok) continue;
        const data = await res.json();
        if (Array.isArray(data?.variants) && data.variants.length) {
          this.doubleWallProductData = data;
          console.log('[Wholesale DW] Loaded external ProductJSON:', h);
          return this.doubleWallProductData;
        }
      } catch (_) {}
    }
    console.warn('[Wholesale DW] Could not load external ProductJSON');
    return null;
  }

  async updatePricingTable() {
    const formEl = document.querySelector('#product-form-cup-wholesale');
    const tbody = formEl ? formEl.querySelector('#quantity-grid-body') : document.getElementById('quantity-grid-body');
    if (!tbody) return;

    const renderId = (this._pricingRenderCounter = (this._pricingRenderCounter || 0) + 1);

    const pricingKey = this.getPricingKey();
    const variants = this.variantMapping[pricingKey];
    
    console.log('Updating pricing for:', pricingKey, variants);
    
    if (!variants) {
      if (renderId !== this._pricingRenderCounter) return;
      tbody.innerHTML = '<tr><td colspan="5" style="text-align: center; padding: 2em;">No pricing available for this configuration</td></tr>';
      return;
    }
    
    // Load product data for price lookup (but don't require it)
    await this.loadProductData();
    
    const frag = document.createDocumentFragment();

    // Get available quantities for this configuration (wholesale quantities) and prefetch prices
    const quantities = [10000, 16000, 32000, 50000, 64000];
    await this.fetchVariantPricesBatch(Object.values(variants || {}));
    const externalDW = this.selectedWall === 'Double' ? await this.loadDoubleWallProductData() : null;
    
    for (let i = 0; i < quantities.length; i++) {
      const qty = quantities[i];
      const variantId = variants[qty.toString()];
      
      // Try to find variant in product data
      let variant = null;
      let variantPrice = 0;
      let unitPrice = 0;
      
      if (this.productData && variantId) {
        variant = this.productData.variants.find(v => v.id == variantId);
      }
      if (!variant && externalDW && variantId) {
        variant = externalDW.variants.find(v => String(v.id) === String(variantId));
      }
      
      console.log(`[Pricing Debug] ${pricingKey} - Qty: ${qty}, VariantID: ${variantId}, Found: ${!!variant}`);
      
      if (variant) {
        // Use live Shopify pricing (variant.price is cents in Shopify JSON)
        const cents = typeof variant.price === 'string' ? parseInt(variant.price, 10) : Number(variant.price);
        variantPrice = (isNaN(cents) ? 0 : cents) / 100;
        unitPrice = variantPrice / qty;
      } else {
        // Try live variant fetch by ID for wholesale too
        let live = null;
        try {
          const res = await fetch(`/variants/${variantId}.json`, { headers: { 'Accept': 'application/json,text/plain,*/*' } });
          if (res.ok) {
            let data;
            try { data = await res.clone().json(); }
            catch(_) { const t = await res.text(); try { data = JSON.parse(t); } catch(_) {}
            }
            const v = data?.variant || data;
            if (v && v.price != null) {
              let p = typeof v.price === 'string' ? parseFloat(v.price) : Number(v.price);
              if (p > 100 && Number.isInteger(p)) p = p / 100;
              if (isFinite(p)) live = p;
            }
          }
        } catch(_) {}
        if (live != null) {
          variantPrice = live;
          unitPrice = live / qty;
        } else {
          // Fallback tiers
          console.warn(`Using fallback pricing for ${pricingKey} ${qty} units (variant ${variantId} not found or empty)`);
          if (qty >= 64000) unitPrice = 0.18;
          else if (qty >= 50000) unitPrice = 0.20;
          else if (qty >= 32000) unitPrice = 0.22;
          else if (qty >= 16000) unitPrice = 0.25;
          else unitPrice = 0.28; // 10,000
          if (pricingKey.includes('22oz') || pricingKey.includes('24oz')) unitPrice *= 2.2;
          else if (pricingKey.includes('16oz')) unitPrice *= 1.6;
          else if (pricingKey.includes('12oz')) unitPrice *= 1.3;
          else if (pricingKey.includes('8oz')) unitPrice *= 1.1;
          variantPrice = unitPrice * qty;
        }
      }
      
      const row = document.createElement('tr');
      row.classList.add('quantity-row');
      row.dataset.quantity = qty;
      
      // Make entire row clickable
      row.addEventListener('click', () => {
        const radio = row.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = true;
          this.selectedQuantity = qty;
          this.currentUnitPrice = unitPrice;
          this.updateRowSelection();
          this.updateSelectedQuantityDisplay();
          this.updateColourAvailability();
          this.updateOrderSummary();
          this.updateMediaGalleryForSelectedVariant();
        }
      });
      
      // Radio button
      const radioCell = document.createElement('td');
      const radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'quantity_selection';
      radio.value = qty;
      radio.addEventListener('change', () => {
        if (radio.checked) {
          this.selectedQuantity = qty;
          this.currentUnitPrice = unitPrice;
          this.updateRowSelection();
          this.updateSelectedQuantityDisplay();
          this.updateColourAvailability();
          this.updateOrderSummary();
          this.updateMediaGalleryForSelectedVariant();
        }
      });
      
      // Pre-select first option or maintain current selection
      if ((i === 0 && this.selectedQuantity === null) || qty === this.selectedQuantity) {
        radio.checked = true;
        this.selectedQuantity = qty;
        this.currentUnitPrice = unitPrice;
        row.classList.add('selected');
      }
      
      radioCell.appendChild(radio);
      row.appendChild(radioCell);
        
      // Quantity
      const qtyCell = document.createElement('td');
      qtyCell.textContent = qty.toLocaleString();
      row.appendChild(qtyCell);

      // Cartons
      const cartonsCell = document.createElement('td');
      const cartons = qty / this.UNITS_PER_CARTON;
      cartonsCell.textContent = this.decimalToFraction(cartons);
      row.appendChild(cartonsCell);

      // Unit Price with membership discount
      const unitPriceCell = document.createElement('td');
      
      // Check for membership pricing
      let memberTier = null;
      let discountPercent = 0;
      
      // Get customer tags from data attribute
      const customerTags = document.querySelector('[data-customer-tags]')?.dataset.customerTags || '';
      if (customerTags) {
        const tags = customerTags.toLowerCase().split(',').map(tag => tag.trim());
        
        // Fallback to legacy logic for bronze/silver/gold/trade
        if (tags.includes('trade')) {
          memberTier = 'trade';
          discountPercent = 20;
        } else if (tags.includes('gold')) {
          memberTier = 'gold';
          discountPercent = 15;
        } else if (tags.includes('silver')) {
          memberTier = 'silver';
          discountPercent = 10;
        } else if (tags.includes('bronze')) {
          memberTier = 'bronze';
          discountPercent = 5;
        }
      }
      
      if (memberTier && discountPercent > 0) {
        const discountedUnitPrice = unitPrice * (1 - discountPercent / 100);
        console.log(`[Membership Debug] Wholesale Unit Price - Original: $${unitPrice.toFixed(3)}, Discounted: $${discountedUnitPrice.toFixed(3)}, Tier: ${memberTier}`);
        
        unitPriceCell.innerHTML = `
          <span class="original-price">$${unitPrice.toFixed(3)}</span>
          <span class="member-price member-${memberTier}">$${discountedUnitPrice.toFixed(3)}</span>
        `;
      } else {
        unitPriceCell.textContent = `$${unitPrice.toFixed(3)}`; // 3 decimal places for wholesale
      }
      row.appendChild(unitPriceCell);

      // Total Price with membership discount
      const totalCell = document.createElement('td');
      
      if (memberTier && discountPercent > 0) {
        const discountedTotal = variantPrice * (1 - discountPercent / 100);
        console.log(`[Membership Debug] Wholesale Total Price - Original: $${variantPrice.toFixed(2)}, Discounted: $${discountedTotal.toFixed(2)}, Tier: ${memberTier}`);
        
        totalCell.innerHTML = `
          <span class="original-price">$${variantPrice.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${discountedTotal.toFixed(2)}</span>
        `;
      } else {
        totalCell.textContent = `$${variantPrice.toFixed(2)}`;
      }
      row.appendChild(totalCell);

      frag.appendChild(row);
    }

    if (renderId !== this._pricingRenderCounter) return;
    tbody.innerHTML = '';
    tbody.appendChild(frag);

    this.updateRowSelection();
    this.updateSelectedQuantityDisplay();
    this.updateOrderSummary();
    // Ensure the hidden Shopify variant input and media reflect the current selection
    this.updateMediaGalleryForSelectedVariant();
  }

  // Normalize money values coming from Shopify (handle cents vs dollars)
  normalizeMoney(value) {
    const num = typeof value === 'string' ? parseFloat(value) : Number(value);
    if (!isFinite(num)) return 0;
    // If looks like cents (e.g., 17500), convert to dollars
    return num >= 1000 ? Math.round(num) / 100 : num;
  }

  async variantExists(variantId) {
    try {
      const endpoints = [
        `/variants/${variantId}.json`,
        `/variants/${variantId}.js`
      ];
      for (const url of endpoints) {
        try {
          const res = await fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
          if (!res.ok) continue;
          const data = await res.json();
          const v = data?.variant || data;
          if (v && v.id) return true;
        } catch (_) {
          // try next
        }
      }
      return false;
    } catch (_) {
      return false;
    }
  }

  // Resolve a valid, published variant ID for size + quantity from live product data
  async resolveVariantIdOrThrow(size, qty) {
    await this.loadProductData();

    const qtyStr = String(qty);
    const mappedId = this.variantMapping?.[size]?.[qtyStr];

    // Trust mapped ID first (same source the pricing table uses)
    if (mappedId) {
      console.log('[Resolver] Using mapped variant ID (trusted):', mappedId, { size, qty });
      return String(mappedId);
    } else {
      console.warn('[Resolver] No mapped ID for', { size, qty });
    }

    // Fallback: search productData by title/options for size + qty
    const qtyDigits = String(qty).replace(/[^0-9]/g, '');
    const variants = Array.isArray(this.productData?.variants) ? this.productData.variants : [];
    const sizeNorm = (size || '').toString().trim().toLowerCase();
    const qtyBoundaryRegex = new RegExp(`(^|\\D)${qtyDigits}(\\D|$)`);
    const candidates = variants.filter(v => {
      const titleRaw = (v.title || '').toString();
      const title = titleRaw.toLowerCase();
      const opts = [v.option1, v.option2, v.option3].map(o => (o || '').toString());

      const sizeMatch =
        opts.some(o => o.toLowerCase().trim() === sizeNorm) ||
        title.includes(`${sizeNorm} `) ||
        title.startsWith(`${sizeNorm} /`) ||
        title.includes(`${sizeNorm}/`);

      const optHasQty = opts.some(o => o.replace(/[^0-9]/g, '') === qtyDigits);
      const titleDigits = titleRaw.replace(/[^0-9]/g, '');
      const titleHasQty = titleDigits.includes(qtyDigits); // allows formats like "10,000"
      const qtyMatch = optHasQty || titleHasQty;

      return sizeMatch && qtyMatch;
    });

    for (const v of candidates) {
      if (await this.variantExists(v.id)) {
        console.log('[Resolver] Using fallback resolved variant ID:', v.id, { size, qty });
        return String(v.id);
      }
      console.warn('[Resolver] Candidate variant not published/valid, skipping:', v.id);
    }

    console.warn('[Resolver] No candidates matched in productData', { size, qty, qtyDigits, mappedId });
    throw new Error(`We couldn't find a valid configuration for ${size} - ${qty.toLocaleString()} units. Please contact support.`);
  }

  async loadPlateFeePrice() {
    try {
      const urls = [
        `/variants/${this.plateFeeVariantId}.json`,
        `/variants/${this.plateFeeVariantId}.js`
      ];
      for (const url of urls) {
        const res = await fetch(url, { credentials: 'same-origin' });
        if (!res.ok) continue;
        const data = await res.json();
        const variant = data.variant || data;
        const priceStr = variant && (variant.price || (variant.presentment_prices && variant.presentment_prices[0]?.price?.amount));
        const unit = this.normalizeMoney(priceStr);
        if (!isNaN(unit) && unit > 0) {
          this.plateFeeUnitPrice = Math.max(175, unit);
          console.log('[PlateFee] Loaded plate fee unit price:', this.plateFeeUnitPrice);
          return;
        }
      }
      console.warn('[PlateFee] Unable to load plate fee price; using fallback $175');
    } catch (e) {
      console.warn('[PlateFee] Error loading plate fee price; using fallback $175', e);
    }
  }

  calculateUnitPrice() {
    // Return the cached unit price from live data
    return this.currentUnitPrice || 0;
  }

  // Calculate plate fees based on selected colours and turnaround
  calculatePlateFees() {
    const colours = Number(this.selectedColours) || 0;
    const isUrgent = this.selectedTurnaround !== 'standard';
    const plateFee = isUrgent ? this.URGENT_PLATE_FEE : this.STANDARD_PLATE_FEE;
    const total = colours * plateFee;
    return total;
  }

  // Helper method to calculate variant total price
  calculateVariantTotalPrice() {
    // Calculate total price from live variant data
    const unitPrice = this.calculateUnitPrice();
    const totalPrice = unitPrice * this.selectedQuantity;
    
    console.log(`[VariantTotalPrice] Unit: $${unitPrice}, Qty: ${this.selectedQuantity}, Total: $${totalPrice}`);
    
    return totalPrice;
  }

  // Smart number formatting - only show decimals if needed, max 3 decimals for wholesale
  formatNumber(number) {
    const rounded = Math.round(number * 1000) / 1000; // Round to 3 decimal places
    return rounded % 1 === 0 ? rounded.toString() : rounded.toFixed(3);
  }

  updateRowSelection() {
    // Remove selection from all rows
    document.querySelectorAll('.quantity-row').forEach(row => {
      row.classList.remove('selected');
    });
    
    // Add selection to current row
    if (this.selectedQuantity) {
      const selectedRow = document.querySelector(`[data-quantity="${this.selectedQuantity}"]`);
      if (selectedRow) {
        selectedRow.classList.add('selected');
      }
    }
  }
  
  updateSelectedQuantityDisplay() {
    // Update any selected quantity display elements
    const selectedQtyElements = document.querySelectorAll('.selected-quantity-display');
    selectedQtyElements.forEach(el => {
      el.textContent = this.selectedQuantity ? this.selectedQuantity.toLocaleString() : '';
    });
    
    // Update order summary
    this.updateOrderSummary();
  }
  
  updateOrderSummary() {
    if (!this.selectedQuantity) return;
    
    // Get current pricing for display calculations
    const pricingKey = this.getPricingKey();
    const variants = this.variantMapping[pricingKey];
    const variant = variants[this.selectedQuantity.toString()];
    
    if (!variant && !this.currentUnitPrice) {
      console.warn(`Variant not found for quantity: ${this.selectedQuantity}`);
      return;
    }
    
    let unitPrice = this.calculateUnitPrice();
    let lidPrice = 0;
    let plateFee = this.calculatePlateFees();
    let rushFee = 0;
    let totalPrice = this.selectedQuantity * unitPrice;

    // Add lids cost (for display purposes)
    if (this.requireLids) {
      const lidUnitPrice = this.LID_PRICE_HIGH_QTY; // Always high qty for wholesale
      lidPrice = this.selectedQuantity * lidUnitPrice;
      totalPrice += lidPrice;
      document.getElementById('summary-lid-row').style.display = '';
      document.getElementById('summary-lid-price').textContent = `$${lidPrice.toFixed(2)}`;
    } else {
      document.getElementById('summary-lid-row').style.display = 'none';
      document.getElementById('summary-lid-price').textContent = '$0.00';
    }

    // Add plate fees
    totalPrice += plateFee;
    const plateFeeEl = document.getElementById('summary-plate-fee');
    if (plateFeeEl) plateFeeEl.textContent = `$${plateFee.toFixed(2)}`;

    // Add rush surcharge (for display purposes)
    const rushMultiplier = this.RUSH_MULTIPLIERS[this.selectedTurnaround] || 1.0;
    if (rushMultiplier > 1.0) {
      // Only apply rush to cups, not lids or plates
      const baseCupTotal = this.selectedQuantity * this.calculateUnitPrice();
      rushFee = Math.round(baseCupTotal * (rushMultiplier - 1));
      totalPrice += rushFee;
      document.getElementById('summary-rush-row').style.display = '';
      document.getElementById('summary-rush-fee').textContent = `$${rushFee.toFixed(2)}`;
    } else {
      document.getElementById('summary-rush-row').style.display = 'none';
      document.getElementById('summary-rush-fee').textContent = '$0.00';
    }

    // Update summary elements with membership discounts
    const summaryQuantity = document.getElementById('summary-quantity');
    const summaryUnitPrice = document.getElementById('summary-unit-price');
    const summaryTotal = document.getElementById('summary-total');
    
    // Check for membership pricing in order summary
    let memberTier = null;
    let discountPercent = 0;
    
    // Get customer tags from data attribute
    const customerTags = document.querySelector('[data-customer-tags]')?.dataset.customerTags || '';
    if (customerTags) {
      const tags = customerTags.toLowerCase().split(',').map(tag => tag.trim());
      
      if (tags.includes('trade')) {
        memberTier = 'trade';
        discountPercent = 20;
      } else if (tags.includes('gold')) {
        memberTier = 'gold';
        discountPercent = 15;
      } else if (tags.includes('silver')) {
        memberTier = 'silver';
        discountPercent = 10;
      } else if (tags.includes('bronze')) {
        memberTier = 'bronze';
        discountPercent = 5;
      }
    }
    
    if (summaryQuantity) summaryQuantity.textContent = this.selectedQuantity.toLocaleString();
    
    // Apply membership discount to unit price display
    if (summaryUnitPrice) {
      if (memberTier && discountPercent > 0) {
        const discountedUnitPrice = unitPrice * (1 - discountPercent / 100);
        summaryUnitPrice.innerHTML = `
          <span class="original-price">$${unitPrice.toFixed(3)}</span>
          <span class="member-price member-${memberTier}">$${discountedUnitPrice.toFixed(3)}</span>
        `;
      } else {
        summaryUnitPrice.textContent = `$${unitPrice.toFixed(3)}`; // 3 decimals for wholesale
      }
    }
    
    // Apply membership discount to total price display
    if (summaryTotal) {
      if (memberTier && discountPercent > 0) {
        const discountedTotal = totalPrice * (1 - discountPercent / 100);
        summaryTotal.innerHTML = `
          <span class="original-price">$${totalPrice.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${discountedTotal.toFixed(2)}</span>
        `;
      } else {
        summaryTotal.textContent = `$${totalPrice.toFixed(2)}`;
      }
    }
  }

  async addToCart() {
    const button = document.getElementById('custom-add-to-cart-btn');
    if (!button) return;

    // Show loading state
    button.classList.add('loading');
    button.disabled = true;

    try {
      await this.loadProductData();

      // Resolve a fresh, valid cup variant ID from live product data
      const cupVariantId = await this.resolveVariantIdOrThrow(this.selectedSize, this.selectedQuantity);
      console.log('[AddToCart] Cup variant ID:', cupVariantId);

      // Create FormData to handle file upload and multiple line items
      const formData = new FormData();
      const epkCartGroupId = `epkorder-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
      
      // Add the main cup variant
      formData.append('items[0][id]', cupVariantId);
      formData.append('items[0][quantity]', '1');
      formData.append('items[0][properties][_epk_group]', epkCartGroupId);
      formData.append('items[0][properties][Size]', this.selectedSize);
      formData.append('items[0][properties][Print Type]', this.selectedPrintType);
      formData.append('items[0][properties][Quantity]', this.selectedQuantity);
      formData.append('items[0][properties][Colours]', this.selectedColours);
      // Recompute a live unit price from ProductJSON for the selected variant
      let liveUnit = this.calculateUnitPrice();
      try {
        await this.loadProductData();
        const pk = this.getPricingKey();
        const variants = this.variantMapping[pk] || {};
        const selId = variants[String(this.selectedQuantity)];
        const v = this.productData?.variants?.find(v => v.id.toString() === String(selId));
        if (v) {
          const cents = typeof v.price === 'string' ? parseFloat(v.price) : Number(v.price);
          const total = (isFinite(cents) ? cents : 0) / 100;
          if (this.selectedQuantity) liveUnit = total / this.selectedQuantity;
        }
      } catch (_) {}
      formData.append('items[0][properties][Price/Unit]', `$${liveUnit.toFixed(3)}`);
      
      // Add the uploaded file
      const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
      if (fileInput && fileInput.files[0]) {
        formData.append('items[0][properties][Design File]', fileInput.files[0]);
      }

      let itemIndex = 1; // Start next items at index 1

      // Add separate lid variant if lids are required
      if (this.requireLids) {
        const lidQuantityTier = this.getLidQuantityTier(this.selectedQuantity);
        const lidVariantId = this.lidVariantMapping[this.lidColor]?.[lidQuantityTier];
        if (lidVariantId && await this.variantExists(lidVariantId)) {
          console.log('[AddToCart] Lid variant ID:', String(lidVariantId), { color: this.lidColor, qty: this.selectedQuantity });
          formData.append(`items[${itemIndex}][id]`, lidVariantId);
          formData.append(`items[${itemIndex}][quantity]`, '1');
          formData.append(`items[${itemIndex}][properties][Type]`, 'Lids');
          formData.append(`items[${itemIndex}][properties][Color]`, this.lidColor);
          formData.append(`items[${itemIndex}][properties][Quantity]`, this.selectedQuantity);
          formData.append(`items[${itemIndex}][properties][For Cup Size]`, this.selectedSize);
          formData.append(`items[${itemIndex}][properties][_epk_group]`, epkCartGroupId);
          
          itemIndex++;
          console.log('[AddToCart Debug] Added lid variant:', lidVariantId);
        } else {
          console.warn('[AddToCart Debug] Lid variant invalid or unpublished, skipping lids for', this.lidColor, lidQuantityTier, lidVariantId);
        }
      }

      // Add single plate fee line item for all colours (like other products)
      const isUrgent = this.selectedTurnaround !== 'standard';
      const plateVariantId = isUrgent ? urgentPlateFeeVariantId : printingPlateFeeVariantId;
      const plateFeePrice = isUrgent ? this.URGENT_PLATE_FEE : this.STANDARD_PLATE_FEE;
      
      console.log('[AddToCart Debug] Checking plate fees:', { 
        plateVariantId, 
        selectedColours: this.selectedColours, 
        isUrgent, 
        turnaround: this.selectedTurnaround 
      });
      
      if (plateVariantId && this.selectedColours > 0 && await this.variantExists(plateVariantId)) {
        const totalPlateFee = this.selectedColours; // Quantity = number of colours
        formData.append(`items[${itemIndex}][id]`, plateVariantId);
        formData.append(`items[${itemIndex}][quantity]`, totalPlateFee);
        formData.append(`items[${itemIndex}][properties][Type]`, 'Printing Plates');
        formData.append(`items[${itemIndex}][properties][Colours]`, this.selectedColours);
        formData.append(`items[${itemIndex}][properties][For Order]`, `${this.selectedSize} ${this.selectedQuantity} cups`);
        formData.append(`items[${itemIndex}][properties][Turnaround]`, this.selectedTurnaround);
        formData.append(`items[${itemIndex}][properties][_Plate Fee]`, `${this.selectedColours} Colour${this.selectedColours > 1 ? 's' : ''} @ $${plateFeePrice} each`);
        formData.append(`items[${itemIndex}][properties][_epk_group]`, epkCartGroupId);
        
        itemIndex++;
        console.log('[AddToCart Debug] Added plate fee for', this.selectedColours, 'colours using variant:', plateVariantId, isUrgent ? '(urgent)' : '(standard)');
      } else if (this.selectedColours > 0) {
        console.warn('[AddToCart Debug] Plate fee variant not found or invalid, skipping plate fees:', plateVariantId);
      }

      // Add rush fee as separate product if rushed turnaround is selected (skip for members)
      const rushMultiplier = this.RUSH_MULTIPLIERS[this.selectedTurnaround] || 1.0;
      if (rushMultiplier > 1.0) {
        // Check if user is logged in with membership (bronze, silver, gold tags)
        const customerTags = window.customer?.tags || [];
        const isMember = customerTags.some(tag => 
          tag.toLowerCase().includes('bronze') || 
          tag.toLowerCase().includes('silver') || 
          tag.toLowerCase().includes('gold')
        );
        
        {
          // Rush fee charged at FULL price for everyone (members included). Shopify's automatic
          // member discount applies it once — consistent with retail cups.
          const baseCupTotal = this.selectedQuantity * this.calculateUnitPrice();
          const rushFeeAmount = baseCupTotal * (rushMultiplier - 1);
          const rushFeeQuantity = Math.round(rushFeeAmount);

          if (rushFeeQuantity > 0) {
            formData.append(`items[${itemIndex}][id]`, '50675778126106'); // $1 rush fee product
            formData.append(`items[${itemIndex}][quantity]`, rushFeeQuantity);
            formData.append(`items[${itemIndex}][properties][Base Order Total]`, `$${baseCupTotal.toFixed(2)}`);
            formData.append(`items[${itemIndex}][properties][Rush Fee (${this.selectedTurnaround})]`, `$${rushFeeAmount.toFixed(2)}`);
            formData.append(`items[${itemIndex}][properties][Turnaround]`, this.selectedTurnaround);
            formData.append(`items[${itemIndex}][properties][_epk_group]`, epkCartGroupId);

            itemIndex++;
            console.log('[AddToCart Debug] Added rush fee:', rushFeeQuantity, 'x $1 for', this.selectedTurnaround);
          }
        }
      }

      // Submit to cart using FormData (supports file uploads) with JSON Accept
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' },
        body: formData
      });

      if (!response.ok) {
        let errMsg = `Failed to add to cart: ${response.status}`;
        try {
          const errJson = await response.json();
          if (errJson && errJson.description) errMsg += ` - ${errJson.description}`;
        } catch (_) {
          // ignore parse error
        }
        throw new Error(errMsg);
      }

      // Success
      document.dispatchEvent(new CustomEvent('cart:updated'));
      localStorage.setItem('cartAddSuccess', 'true');
      setTimeout(() => { window.location.reload(); }, 600);

    } catch (error) {
      console.error('Cart error:', error);
      this.showMessage(`Error adding to cart: ${error.message}`, 'error');
    } finally {
      button.classList.remove('loading');
      button.disabled = false;
    }
  }
  
  showMessage(text, type) {
    console.log('showMessage called:', text, type);
    
    // Remove existing messages
    const existingMessages = document.querySelectorAll('.cup-message');
    existingMessages.forEach(msg => msg.remove());
    
    // Create new toast message
    const message = document.createElement('div');
    message.className = `cup-message cup-${type}-message cup-toast-message`;
    message.textContent = text;
    
    // Position the toast near the Add to cart button
    const addToCartButton = document.querySelector('#custom-add-to-cart-btn') || 
                           document.querySelector('.custom-add-to-cart-button') ||
                           document.querySelector('.product-form-cup-wholesale__cart-submit') || 
                           document.querySelector('#product-form-cup-wholesale button[type="submit"]') ||
                           document.querySelector('button[name="add"]');
    
    console.log('Found button:', addToCartButton);
    
    if (addToCartButton) {
      const buttonRect = addToCartButton.getBoundingClientRect();
      console.log('Button rect:', buttonRect);
      
      // Position the toast near the button
      message.style.position = 'fixed';
      message.style.top = `${buttonRect.top + (buttonRect.height / 2) - 30}px`;
      message.style.right = '20px';
      message.style.zIndex = '9999';
      
      document.body.appendChild(message);
      console.log('Toast appended to body');
      
      // Trigger slide-in animation
      setTimeout(() => {
        message.classList.add('show');
        console.log('Toast show class added');
      }, 10);
      
      // Auto-remove after 3 seconds
      setTimeout(() => {
        message.classList.add('hide');
        setTimeout(() => {
          message.remove();
          console.log('Toast removed');
        }, 300); // Allow fade-out animation to complete
      }, 3000);
    } else {
      console.warn('Add to cart button not found, falling back to simple display');
      // Fallback: just append to body with default positioning
      message.style.position = 'fixed';
      message.style.top = '20px';
      message.style.right = '20px';
      message.style.zIndex = '9999';
      
      document.body.appendChild(message);
      
      setTimeout(() => {
        message.classList.add('show');
      }, 10);
      
      setTimeout(() => {
        message.classList.add('hide');
        setTimeout(() => {
          message.remove();
        }, 300);
      }, 3000);
    }
  }
  
  // Helper function to convert decimal to fraction
  decimalToFraction(decimal) {
    if (decimal >= 1) {
      return this.formatNumber(decimal);
    }
    
    // Common fractions for carton sizes
    const fractions = {
      0.25: '1/4',
      0.5: '1/2',
      0.75: '3/4'
    };
    
    return fractions[decimal] || this.formatNumber(decimal);
  }

  updateMediaGalleryForSelectedVariant() {
    // Get the correct variant ID based on current selections
    const pricingKey = this.getPricingKey();
    const quantityKey = String(this.selectedQuantity);
    const variantId = this.variantMapping[pricingKey]?.[quantityKey];
    
    if (!variantId) {
      console.log('No variant ID found for:', pricingKey, quantityKey);
      return;
    }

    console.log('Updating for variant ID:', variantId);
    
    // Update variant ID input
    const variantIdInputs = document.querySelectorAll('input[name="id"]');
    variantIdInputs.forEach(input => {
      input.value = variantId;
      console.log('Updated variant input to:', variantId);
    });

    // Update URL
    const currentUrl = new URL(window.location);
    currentUrl.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', currentUrl.toString());
    console.log('Updated URL variant to:', variantId);
    
    // Find the variant's featured media and switch to it
    this.switchToVariantMedia(variantId);
    
    // Trigger a change event on the variant input to let Shopify know
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  
  switchToVariantMedia(variantId) {
    try {
      // Get product data
      const productScript = document.querySelector(`script[id^="ProductJSON-"]`);
      if (!productScript) {
        console.log('No product data script found');
        return;
      }
      
      const productData = JSON.parse(productScript.textContent);
      let variant = productData.variants?.find(v => v.id == variantId);
      
      if (!variant || !variant.featured_media?.id) {
        console.log('No featured media on selected variant, looking for fallback for size:', this.selectedSize);
        const fallbackVariant = this.findVariantWithMediaForSize(this.selectedSize, productData);
        if (!fallbackVariant) {
          console.log('No fallback variant with media found for size:', this.selectedSize);
        return;
        }
        variant = fallbackVariant;
      }
      
      console.log('Switching to media ID:', variant.featured_media.id, 'for variant:', variant.title);
      
      // Find the media gallery component
      const mediaGallery = document.querySelector('media-gallery');
      if (!mediaGallery) {
        console.log('Media gallery component not found');
        return;
      }
      
      // Get the section ID from the media gallery
      const sectionId = mediaGallery.dataset.sectionId;
      const targetMediaId = `${sectionId}-${variant.featured_media.id}`;
      
      console.log('Looking for media with ID:', targetMediaId);
      
      // Find the thumbnail with the matching data-target
      const thumbnail = document.querySelector(`[data-target="${targetMediaId}"]`);
      if (thumbnail) {
        const button = thumbnail.querySelector('button');
        if (button) {
          console.log('Found thumbnail button, clicking it');
          button.click();
          return;
        }
      }
      
      // Fallback: directly call setActiveMedia if thumbnail click didn't work
      console.log('Thumbnail not found, using direct media switching');
      if (mediaGallery.setActiveMedia) {
        mediaGallery.setActiveMedia(targetMediaId, false);
      } else {
        // Manual fallback
        this.manualMediaSwitch(targetMediaId);
      }
      
    } catch (error) {
      console.error('Error switching variant media:', error);
    }
  }
  
  findVariantWithMediaForSize(size, productData) {
    try {
      if (!productData || !Array.isArray(productData.variants)) return null;
      // Prefer exact title prefix match like "4oz /"
      const preferred = productData.variants.find(v => v?.featured_media?.id && (v?.title?.startsWith(`${size} /`)));
      if (preferred) return preferred;
      // Fallback to option1 equality or title includes
      return productData.variants.find(v => v?.featured_media?.id && (v?.option1 === size || v?.title?.includes(`${size} /`)) ) || null;
    } catch (e) {
      console.log('Error finding fallback variant with media:', e);
      return null;
    }
  }
  
  manualMediaSwitch(targetMediaId) {
    console.log('Manual media switch to:', targetMediaId);
    
    // Try to find and activate the target media
    const targetMedia = document.getElementById(targetMediaId);
    if (targetMedia) {
      // Hide all media
      const allMedia = document.querySelectorAll('[id*="-"][id*="media"]');
      allMedia.forEach(media => {
        media.style.display = 'none';
        media.classList.remove('active');
      });
      
      // Show target media
      targetMedia.style.display = 'block';
      targetMedia.classList.add('active');
      
      // Update thumbnails
      const allThumbnails = document.querySelectorAll('[data-target]');
      allThumbnails.forEach(thumb => thumb.classList.remove('active'));
      
      const targetThumbnail = document.querySelector(`[data-target="${targetMediaId}"]`);
      if (targetThumbnail) {
        targetThumbnail.classList.add('active');
      }
      
      console.log('Manual media switch completed');
    } else {
      console.log('Target media not found:', targetMediaId);
    }
  }

  checkCartAddSuccess() {
    const successFlag = localStorage.getItem('cartAddSuccess');
    if (successFlag === 'true') {
      localStorage.removeItem('cartAddSuccess');
      this.showMessage('Added to cart successfully!', 'success');
    }
  }

  preventAutoScroll() {
    // Prevent automatic scrolling behaviors that might interfere with user experience
    // But allow manual scrolling functions like scrollToShippingCalculator
    const blockScrollIntoView = () => {
      const originalScrollIntoView = Element.prototype.scrollIntoView;
      Element.prototype.scrollIntoView = function(options) {
        // Allow manual scrolling (when called by our functions)
        if (options && (options.block === 'manual' || options.behavior === 'smooth')) {
          return originalScrollIntoView.call(this, options);
        }
        // Block automatic scrolling
        console.log('Blocked automatic scrollIntoView');
        return;
      };
    };

    // Apply the scroll blocking
    blockScrollIntoView();

    // Also prevent hash-based scrolling on page load
    if (window.location.hash) {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 1);
    }

    // Prevent scroll restoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    // Block automatic focus scrolling but allow manual focus
    const originalFocus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function(options) {
      const newOptions = { ...options, preventScroll: true };
      return originalFocus.call(this, newOptions);
    };
  }
}

// Initialize the product functionality
document.addEventListener('DOMContentLoaded', function() {
  console.log('✅ Initializing Wholesale Coffee Cup (Recyclable) with class-based approach...');
  
  // Create the class instance which will run async init()
  window.coffeeCupWholesaleProduct = new CoffeeCupWholesaleProduct();
  
  console.log('🎉 Wholesale Coffee Cup (Recyclable) JavaScript loaded successfully!');
});

// Smooth scroll function for ETA button
function scrollToShippingCalculator(event) {
  event.preventDefault();
  
  const shippingCalculator = document.getElementById('shipping-calculator');
  if (shippingCalculator) {
    shippingCalculator.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Smooth scroll function for ETA calculator
function scrollToEtaCalculator(event) {
  event.preventDefault();
  
  const etaCalculatorSection = document.getElementById('eta-calculator-section');
  if (etaCalculatorSection) {
    etaCalculatorSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Legacy function for backwards compatibility
function scrollToDesignUpload(event) {
  event.preventDefault();
  
  const designUploadSection = document.getElementById('design-upload-section');
  if (designUploadSection) {
    designUploadSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
} 